// extracted by mini-css-extract-plugin
export default {"Container":"Notifications_Container__bTgu2","wrapper":"Notifications_wrapper__4KAlJ","right":"Notifications_right__sFtR5","Notifications":"Notifications_Notifications__WoaH4"};